<template>
  <div class="bluefire-wap-wrap rm-page">
    <!-- 顶部栏：与 h5/tools 保持一致的移动端头部 -->
    <wap-header
      :header-text="pageTitle"
      :header-visible="true"
      :back-visible="true"
      :user-list-lock.sync="userListLock" /><!--参数都可以不传-->

    <div class="rm-body">
      <el-form
        v-loading="loading"
        class="rm-form"
        label-position="left"
        label-width="80px"
        @submit.native.prevent>
        <div class="rm-card">
          <div class="rm-grid">

            <!-- 姓名 -->
            <el-form-item class="rm-item">
              <span slot="label" class="rm-label">姓名</span>
              <el-input
                ref="username"
                v-model.trim="editData.username"
                placeholder="请输入姓名"
                :disabled="formReadonly"
                clearable />
            </el-form-item>

            <!-- 昵称 -->
            <el-form-item class="rm-item">
              <span slot="label" class="rm-label">昵称</span>
              <el-input
                v-model.trim="editData.nickname"
                placeholder="请输入昵称"
                :disabled="formReadonly"
                clearable />
            </el-form-item>

            <!-- 电话 -->
            <el-form-item class="rm-item">
              <span slot="label" class="rm-label"><i class="rm-star">*</i>电话</span>
              <el-input
                ref="telInput"
                v-model.trim="editData.tel"
                placeholder="请输入手机号"
                type="tel"
                :disabled="telDisabled"
                clearable
                @blur="checkTel">
                <Copy v-if="editData.tel" slot="append" :content="editData.tel" @copyCallback="copyClick">
                  <span class="rm-append-op">复制</span>
                </Copy>
              </el-input>
              <p class="rm-tip">电话与微信至少填写一项</p>
            </el-form-item>

            <!-- QQ -->
            <el-form-item class="rm-item">
              <span slot="label" class="rm-label">QQ</span>
              <el-input
                ref="qqInput"
                v-model.trim="editData.qq"
                placeholder="请输入 QQ 号"
                type="tel"
                :maxlength="20"
                :disabled="qqDisabled"
                clearable />
            </el-form-item>

            <!-- 微信 -->
            <el-form-item class="rm-item">
              <span slot="label" class="rm-label">微信</span>
              <el-input
                ref="wechatInput"
                v-model.trim="editData.wechat"
                placeholder="请输入微信号"
                :disabled="wechatDisabled"
                clearable>
                <Copy v-if="editData.wechat" slot="append" :content="editData.wechat" @copyCallback="copyClick">
                  <span class="rm-append-op">复制</span>
                </Copy>
              </el-input>
            </el-form-item>

            <!-- 性别 -->
            <el-form-item class="rm-item">
              <span slot="label" class="rm-label">性别</span>
              <el-radio-group
                v-model="editData.gender"
                class="rm-gender-group"
                :disabled="formReadonly">
                <el-radio-button
                  v-for="item in genderOptions"
                  :key="item.value"
                  :label="item.value">{{ item.label }}</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <!-- 意向语言：整行 -->
            <el-form-item class="rm-item rm-item--full rm-item--top">
              <span slot="label" class="rm-label"><i class="rm-star">*</i>意向语言</span>
              <el-checkbox-group v-model="editData.target_lan" class="rm-lan-group">
                <el-checkbox-button
                  v-for="lan in targetLanOptions"
                  :key="lan"
                  :label="lan"
                  :disabled="formReadonly">{{ lan }}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>

            <!-- 渠道来源：五级联动，单列纵向铺开，与上方输入框等长 -->
            <el-form-item class="rm-item rm-item--top">
              <span slot="label" class="rm-label"><i class="rm-star">*</i>渠道来源</span>
              <jm-channel
                v-if="!channelDisabled"
                :key="channelKey"
                ref="channelRef"
                v-model="channelModel"
                :final.sync="channelFinal"
                :is-all="false"
                clearable
                filter />
              <!-- 只读态：jm-channel 的 exclude-disable 模式渲染的是 mounted 时生成的
                   文本快照，数据刷新后不会重算，故自行按渠道字典渲染，保证响应式 -->
              <div v-else class="rm-channel-text">
                <span v-if="channelText">{{ channelText }}</span>
                <span v-else class="rm-channel-empty">未填写渠道</span>
              </div>
              <p v-if="channelDisabled" class="rm-tip">保存后渠道不可修改，如需调整请联系管理员</p>
            </el-form-item>

            <!-- 备注：整行 -->
            <el-form-item class="rm-item rm-item--full rm-item--top">
              <span slot="label" class="rm-label">备注</span>
              <el-input
                v-model="editData.memo"
                class="rm-memo"
                type="textarea"
                :rows="5"
                :maxlength="500"
                :disabled="formReadonly"
                placeholder="请输入备注" />
            </el-form-item>

          </div>
        </div>
      </el-form>
    </div>

    <!-- 底部操作：移动端固定吸底 -->
    <footer class="rm-footer">
      <el-button
        class="rm-btn rm-btn--primary"
        type="primary"
        :loading="saving"
        @click="save()">保存</el-button>
    </footer>
  </div>
</template>

<script>
import header from './compoments/header';
import { mapGetters } from 'vuex';
import { jmChannel } from '@/components/tool';
import { deepClone, getChannelDataset } from '@/utils/utils';
import { targetLan } from '@/dataset/training';
import { gender } from '@/dataset/student';
import customerApi from '@/training/api/customer';

// 精简版不提供「意向部门 / 意向分级」控件，提交时按考培默认值兜底
const DEFAULT_TARGET_COUNTRY = ['1868']; // 1868 = 考培
const DEFAULT_CUSTOMER_CLASSIFY = 50; // 字典最小分级值
const DEFAULT_TARGET_LAN = ['日语']; // 考培资源默认意向语言

const emptyChannel = () => ({
  custom_from: '',
  custom_from_sub: '',
  custom_from_thrid: '',
  custom_from_fourth: '',
  custom_from_fifth: '',
});

export default {
  name: 'ResourceMobileEdit',
  components: {
    'wap-header': header,
    jmChannel,
  },
  beforeRouteEnter(to, from, next) {
    if (to.meta.isNew) {
      next((vm) => {
        vm.setNewCustomerData();
      });
      return true;
    }
    const customerId = to.params.id;
    customerApi.getCustomerById(customerId).then(({ data }) => {
      next((vm) => {
        vm.setCustomerInfo(data);
      });
    }).catch(() => {
      // 注意：此处组件实例尚未创建，只能通过 next() 中断导航
      next({ name: 'resourceManage' });
    });
  },
  data() {
    return {
      userListLock: true, // 头部账号列表锁，由 wap-header 通过 .sync 更新
      loading: false,
      saving: false,
      isNew: false,
      channelKey: 0, // 用于强制重建渠道组件，避免重置后残留子级选项
      channelFinalFlag: false, // 渠道是否选到最后一级，由 jm-channel 通过 update:final 回填
      channelDataset: [], // 渠道字典，只读态用于把渠道 ID 渲染成文本
      channelModel: emptyChannel(),
      // 意向语言选项，取 dataset/training.targetLan 的 label（与 resourceEdit 提交值一致）
      targetLanOptions: targetLan.map(item => item.label),
      // 性别选项，值为字典的 value（男 1 / 女 2 / 未知 3），与 resourceEdit 提交值一致
      genderOptions: gender,
      editData: {
        id: 0,
        creator: '', // 创建人，新建时取当前登录人
        username: '',
        nickname: '',
        gender: '',
        tel: '',
        qq: '',
        wechat: '',
        memo: '',
        customer_status: 13, // 等待处理
        take_wechat: 0, // 是否已添加微信
        identity: ['', ''], // 用户身份
        has_intention: 0, // 是否有报课意向
        target_country: [...DEFAULT_TARGET_COUNTRY],
        target_lan: [...DEFAULT_TARGET_LAN],
        customer_classify: DEFAULT_CUSTOMER_CLASSIFY,
      },
      // 初始值，用于判断「联系方式是否已存在」（已存在则咨询老师不可修改）
      originData: {
        tel: '',
        qq: '',
        wechat: '',
      },
    };
  },
  created() {
    // 兜底：防止 beforeRouteEnter 的 next 回调未执行时缺少创建人信息
    if (this.$route.meta.isNew) {
      this.setNewCustomerData();
    }
    // 渠道字典（带 Lockr 缓存），只读态渲染渠道文本用
    getChannelDataset().then(({ channels }) => {
      this.channelDataset = channels || [];
    });
  },
  watch: {
    // userInfo 由全局守卫的 getConfig 异步写入，就绪后补填创建人
    userInfo(val) {
      if (this.$route.meta.isNew && val && val.userid && !this.editData.creator) {
        this.setNewCustomerData();
      }
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
    pageTitle() {
      return this.isNew ? '新建资源' : '编辑资源';
    },
    /**
     * 整表只读：跨系统查看等场景下不允许编辑
     */
    formReadonly() {
      return !this.isTrainingSite;
    },
    /**
     * 渠道在保存后仅超管可修改，与 resourceEdit 保持一致
     */
    channelDisabled() {
      return !this.isNew && !this.$hasPermission(1);
    },
    /**
     * 渠道是否已选到最后一级
     * 只读态不渲染 jm-channel，拿不到回填值，保存时直接放行
     */
    channelFinal: {
      get() {
        if (this.channelDisabled) {
          return true;
        }
        return this.channelFinalFlag;
      },
      set(val) {
        this.channelFinalFlag = val;
      },
    },
    /**
     * 只读态下的渠道文本（一级 / 二级 / 三级 …）
     */
    channelText() {
      const ids = Object.keys(this.channelModel)
        .map(key => this.channelModel[key])
        .filter(item => item);
      if (!ids.length) {
        return '';
      }
      if (!this.channelDataset.length) {
        return '加载中…';
      }
      const map = {};
      this.channelDataset.forEach((item) => { map[String(item.id)] = item; });
      return ids
        .map(id => (map[String(id)] ? map[String(id)].name : ''))
        .filter(item => item)
        .join(' / ');
    },
    /**
     * 咨询老师（角色 80）不能修改已存在的联系方式
     */
    contactLockedByTeacher() {
      return !this.isNew && this.$hasPermission(80, true);
    },
    telDisabled() {
      if (this.formReadonly) {
        return true;
      }
      return this.contactLockedByTeacher && !!this.originData.tel;
    },
    qqDisabled() {
      if (this.formReadonly) {
        return true;
      }
      return this.contactLockedByTeacher && !!this.originData.qq;
    },
    wechatDisabled() {
      if (this.formReadonly) {
        return true;
      }
      return this.contactLockedByTeacher && !!this.originData.wechat;
    },
  },
  methods: {
    /**
     * 新增模式初始化：创建人 / 采集功能 / 推广人
     */
    setNewCustomerData() {
      this.isNew = true;
      this.editData.creator = this.userInfo.userid;
      this.editData.create_point = -288;
      this.editData.custom_promoter = this.userInfo.userid;
    },
    /**
     * 编辑模式：填充后端数据
     * @param {Object} data
     */
    setCustomerInfo(data) {
      this.channelModel = {
        custom_from: data.custom_from || '',
        custom_from_sub: data.custom_from_sub || '',
        custom_from_thrid: data.custom_from_thrid || '',
        custom_from_fourth: data.custom_from_fourth || '',
        custom_from_fifth: data.custom_from_fifth || '',
      };
      // 后端可能返回 null / ['']，统一转成有效数组
      this.editData = data;
      if (!Array.isArray(this.editData.target_lan)) {
        this.editData.target_lan = [];
      }
      this.editData.target_lan = this.editData.target_lan.filter(item => item);
      this.originData.tel = this.editData.tel || '';
      this.originData.qq = this.editData.qq || '';
      this.originData.wechat = this.editData.wechat || '';
      this.loading = false;
    },
    /**
     * 手机号格式校验，规则与 studentMixin.checkMobile 保持一致
     */
    checkMobile(mobile) {
      return /^\+?\d+$/.test(mobile);
    },
    checkTel(event) {
      const value = (event.target.value || '').trim();
      if (value && !this.checkMobile(value)) {
        this.$message.error('手机号码填写错误！');
        return false;
      }
      this.editData.tel = value;
      return true;
    },
    hasContactInfo(...infos) {
      return infos.some(item => item);
    },
    hasChannel(channels) {
      return Object.values(channels).some(item => item);
    },
    /**
     * 提交数据
     */
    getData4Save() {
      const data = deepClone(this.editData);
      // 渠道五级
      Object.assign(data, this.channelModel);
      // 用户身份（后端返回的是数组，提交时拆成两个字段）
      if (Array.isArray(data.identity) && data.identity.length) {
        [data.user_identity, data.identity_detail] = data.identity;
      }
      delete data.identity;
      delete data.visit_count;
      delete data.visit_time;
      // 精简版未采集意向部门 / 意向分级，按默认值兜底，避免后端校验拦截
      if (!Array.isArray(data.target_country) || !data.target_country.length) {
        data.target_country = [...DEFAULT_TARGET_COUNTRY];
      }
      if (!Array.isArray(data.target_lan) || !data.target_lan.length) {
        data.target_lan = [...DEFAULT_TARGET_LAN];
      }
      if (!data.customer_classify || Number(data.customer_classify) < DEFAULT_CUSTOMER_CLASSIFY) {
        data.customer_classify = DEFAULT_CUSTOMER_CLASSIFY;
      }
      // 创建人兜底：deepClone 走 JSON 序列化，undefined 会被静默丢弃
      if (!data.creator && this.userInfo && this.userInfo.userid) {
        data.creator = this.userInfo.userid;
      }
      return data;
    },
    /**
     * 保存成功后刷新当前页面，不跳转
     * 编辑模式重新拉取详情；新增模式回到空白表单，便于继续录入
     */
    async reload() {
      if (this.isNew || !this.editData.id) {
        this.resetForm();
        return false;
      }
      this.loading = true;
      try {
        const { data } = await customerApi.getCustomerById(this.editData.id);
        // 只更新数据，不重建渠道组件：重建会丢失 jm-channel 内部的选项/文本快照，
        // 重新走异步拉取期间渠道会空白。只读态已改为由 channelText 响应式渲染
        this.setCustomerInfo(data);
        return true;
      } catch (e) {
        this.$message.error('刷新数据失败，请手动刷新页面');
        return false;
      } finally {
        this.loading = false;
      }
    },
    /**
     * 保存
     */
    save() {
      // 姓名 / 昵称不校验，允许为空
      // 联系方式：电话与微信二者都为空才拦截，任一有值即通过
      if (!this.hasContactInfo(this.editData.tel, this.editData.wechat)) {
        this.$message.error('电话与微信至少填写一项');
        this.$refs.telInput.focus();
        return false;
      }
      if (this.editData.tel && !this.checkMobile(this.editData.tel)) {
        this.$message.error('手机号码填写错误！');
        this.$refs.telInput.focus();
        return false;
      }
      if (this.editData.qq && !this.editData.qq.match(/^\d{5,}$/)) {
        this.$message.error('QQ号码格式错误');
        this.$refs.qqInput.focus();
        return false;
      }
      if (!Array.isArray(this.editData.target_lan) || !this.editData.target_lan.length) {
        this.$message.error('意向语言至少选择一项');
        return false;
      }
      if (!this.hasChannel(this.channelModel)) {
        this.$message.error('渠道来源必须填写');
        if (this.$refs.channelRef) {
          this.$refs.channelRef.focus();
        }
        return false;
      }
      if (!this.channelFinal) {
        this.$message.error('渠道来源必须填写完全');
        return false;
      }

      this.saving = true;
      return new Promise((resolve, reject) => {
        this.$http._post({
          url: '/training/customer/resource',
          data: this.getData4Save(),
        }).then(({ data }) => {
          this.saving = false;
          this.$message.success('保存成功');
          // 保存后停留在当前页，重新加载数据
          this.reload();
          resolve(data);
        }, (err) => {
          this.saving = false;
          reject(err);
        }).catch((e) => {
          this.saving = false;
          reject(e);
        });
      }).catch(() => {});
    },
    /**
     * 重置表单（含渠道组件重建）
     */
    resetForm() {
      const creator = this.userInfo.userid;
      this.editData = {
        id: 0,
        username: '',
        nickname: '',
        gender: '',
        tel: '',
        qq: '',
        wechat: '',
        memo: '',
        customer_status: 13,
        take_wechat: 0,
        identity: ['', ''],
        has_intention: 0,
        target_country: [...DEFAULT_TARGET_COUNTRY],
        target_lan: [...DEFAULT_TARGET_LAN],
        customer_classify: DEFAULT_CUSTOMER_CLASSIFY,
        creator,
        create_point: -288,
        custom_promoter: creator,
      };
      this.channelModel = emptyChannel();
      this.channelFinal = false;
      this.channelKey += 1;
      this.originData = { tel: '', qq: '', wechat: '' };
    },
    copyClick() {
      this.$message.success('复制成功');
    },
  },
};
</script>

<style scoped>
/* ===== 移动优先：默认样式即手机样式 ===== */
/* 外层用 h5 通用的 bluefire-wap-wrap（全局样式：padding-top 8vh 让位固定头部） */
.rm-page {
  padding-bottom: 88px; /* 让位吸底按钮 + 安全区 */
  -webkit-text-size-adjust: 100%;
}

.rm-body {
  padding: 14px 14px 24px;
}

.rm-card {
  padding: 4px 16px 16px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.rm-grid {
  display: grid;
  grid-template-columns: 1fr; /* 手机：单列 */
  gap: 0;
}

/* 表单项：iOS 设置列表风格，细分割线分隔 */
.rm-form /deep/ .el-form-item {
  margin-bottom: 0;
  padding: 12px 0;
  border-bottom: 1px solid #f2f3f5;
}

.rm-form /deep/ .el-form-item:last-child {
  border-bottom: none;
}

.rm-form /deep/ .el-form-item__label {
  float: left;
  padding: 0 12px 0 0;
  line-height: 46px;
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  text-align: left;
  white-space: nowrap;
}

.rm-form /deep/ .el-form-item__content {
  line-height: 46px;
}

/* 多行控件（意向语言 / 渠道 / 备注）：label 顶部对齐 */
.rm-form /deep/ .rm-item--top .el-form-item__label {
  line-height: 24px;
  padding-top: 11px;
}

.rm-label {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
}

.rm-star {
  margin-right: 2px;
  color: #f56c6c;
  font-style: normal;
}

.rm-tip {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
}

/* 输入框 / 文本域：放大圆角 */
.rm-form /deep/ .el-input__inner,
.rm-form /deep/ .el-textarea__inner {

}

.rm-form /deep/ .el-input__inner {
  height: 46px;
  font-size: 16px; /* 防止 iOS 聚焦时自动放大 */
}

.rm-form /deep/ .el-textarea__inner {
  font-size: 16px;
}

.rm-form /deep/ .el-form-item.is-error .el-input__inner {
  border-color: #dcdfe6;
}

/* 复合型输入框：复制按钮作为 el-input 的后置内容（append 插槽），
   采用 Element 默认的后置区域外观，与输入框连成一体 */
.rm-form /deep/ .el-input-group__append .copy {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.rm-append-op {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  line-height: 1;
  color: #409eff;
  cursor: pointer;
}

.rm-memo {
  font-size: 15px;
}

/* 只读态渠道文本 */
.rm-channel-text {
  min-height: 46px;
  padding: 12px 0;
  font-size: 15px;
  line-height: 22px;
  color: #303133;
  word-break: break-all;
}

.rm-channel-empty {
  color: #c0c4cc;
}

/* 性别 / 意向语言：按钮组自动换行，移动端好点击 */
.rm-form /deep/ .rm-lan-group,
.rm-form /deep/ .rm-gender-group {
  display: flex;
  flex-wrap: wrap;
  line-height: 1;
}

.rm-form /deep/ .rm-lan-group .el-checkbox-button,
.rm-form /deep/ .rm-gender-group .el-radio-button {
  margin: 0 8px 8px 0;
}

.rm-form /deep/ .rm-lan-group .el-checkbox-button__inner,
.rm-form /deep/ .rm-gender-group .el-radio-button__inner {
  min-width: 68px;
  padding: 9px 14px;
  border: 1px solid #dcdfe6; /* 完整边框，使每个按钮成为独立的圆角按钮 */
  border-radius: 8px;
  font-size: 14px;
}

/* 选中态：主色实心高亮，并清除 Element 默认的连体左阴影，
   否则独立圆角下选中项左缘会出现一条多余的蓝线/灰色边框错位 */
.rm-form /deep/ .rm-lan-group .el-checkbox-button.is-checked .el-checkbox-button__inner {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
  box-shadow: none;
}

.rm-form /deep/ .rm-gender-group .el-radio-button.is-active .el-radio-button__inner {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
  box-shadow: none;
}

/* 未选中项 hover：边框与文字变主色，给出可点反馈 */
.rm-form /deep/ .rm-lan-group .el-checkbox-button:not(.is-checked) .el-checkbox-button__inner:hover,
.rm-form /deep/ .rm-gender-group .el-radio-button:not(.is-active) .el-radio-button__inner:hover {
  color: #409eff;
  border-color: #409eff;
}

/* 渠道五级联动：纵向铺满，与上方输入框等长 */
.rm-form /deep/ .jm-channel-select {
  display: block;
  width: 100%;
}

.rm-form /deep/ .jm-channel-select .el-select {
  display: block;
  width: 100% !important;
  margin: 0 0 10px;
}

.rm-form /deep/ .jm-channel-select .el-select .el-input__inner {
  height: 44px;
}

/* 底部按钮：手机吸底 */
.rm-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 11;
  display: flex;
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #ebeef5;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.04);
}

.rm-btn {
  flex: 1;
  height: 46px;
  font-size: 16px;
  border-radius: 10px;
}

.rm-btn--primary {
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}
</style>
